import { useMemo, useCallback } from 'react';
import { useConfig, useSettings } from '@vmos2/providers';
import { useHybridApp, useLocale, useRequest } from '@vmos2/utils';
import { userApi } from '@vmos2/core';

export const useGoogleWalletPass = () => {
  const config = useConfig();
  const settings = useSettings();
  const { locale } = useLocale(config, settings);
  const { S3_URL, bootstrap } = config;
  const { hybridApp } = useHybridApp();
  const brandUUID = bootstrap?.hostBrands?.[0]?.uuid;

  const buttonImageUrl = useMemo(() => {
    const languageCode = locale.substring(0, locale.indexOf('-')).toUpperCase();

    return `${S3_URL}/static/add-to-google-wallet/add-to-google-wallet-badge-${languageCode}.svg`;
  }, [S3_URL, locale]);

  const isApplicableDevice = useMemo(() => {
    if (hybridApp) {
      const { isReactNativeApp, platformId } = hybridApp;
      return !!(isReactNativeApp && platformId.includes('android'));
    }

    const userAgent = navigator?.userAgent || navigator?.vendor || (window as any)?.opera || '';
    const androidDeviceRegex = /android/i;

    return androidDeviceRegex.test(userAgent) && !hybridApp;
  }, [hybridApp]);

  const [{ isLoading, error }, getWalletPass] = useRequest(
    useCallback(async () => {
      const url = await userApi.post(
        'v1/wallet-pass/google',
        {},
        {
          params: { locale, brandUUID },
          cache: { ttl: 1000 * 60 * 20 },
          id: 'google-wallet-pass',
        }
      );

      window.open(url, '_blank', 'noopener, noreferrer');
    }, [brandUUID, locale])
  );

  return {
    isLoading,
    getWalletPass,
    hasError: !!error,
    isApplicableDevice,
    buttonImageUrl,
  };
};
